import React from "react";
import Chart from "../../../../../components/Charts";
import { BlurSpinner } from "../../../../../components/BlurSpinner";
import { Title, Card } from "./styles";

const Component = ({ data, isLoading }) => {
  return (
    <Card>
      <Title>Gráfico por estados</Title>
      <div style={{ height: 10 }} />
      <BlurSpinner isLoading={isLoading}>
        <Chart.Pie
          data={{
            ...data,
            colors: ["#FF5733", "#F2A900", "#00B398"], // Add your custom colors here
            fill: [
              {
                match: {
                  id: "vencidos",
                },
                id: "linear",
              },
              {
                match: {
                  id: "pendientes",
                },
                id: "dots",
              },
            ],
          }}
        />
      </BlurSpinner>
    </Card>
  );
};

export default Component;
